import { gql } from '@apollo/client';

export const GET_USER_BY_USERNAME_OR_ID = gql`
    query GetUserByUserNameOrId($input: GetUserByUserNameOrIdInput!) {
        getUserByUserNameOrId(input: $input) {
            id
            phone
            firstName
            lastName
            email
            gender
            userName
            bio
            profileImageUrl
            userType
            stores {
                id
                taffiId
                name
                url
                logoImageUrl
                platform
            }
        }
    }
`;
